export default function CtaSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-2xl border border-primary-200/60 bg-gradient-to-br from-primary-500 to-primary-600 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-background-50/10 blur-2xl" aria-hidden="true"></div>
          <div className="pointer-events-none absolute -bottom-12 -right-8 h-44 w-44 rounded-full bg-accent-300/30 blur-2xl" aria-hidden="true"></div>

          <div className="relative mx-auto max-w-2xl">
            <h2 className="font-heading text-2xl leading-snug text-background-50 md:text-4xl">别再去满网乱翻啦，跟着地图吃瓜就行</h2>
            <p className="mt-4 text-sm text-primary-50/90 md:text-base">
              从今天起，把吃瓜入口网当成你的瓜田总站。无论是想追最新事件，还是想找个冷门板块深挖，一张地图、一个入口就能搞定。
            </p>
            <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
              <a href="#ranking" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm text-primary-600 transition-all hover:-translate-y-0.5 hover:bg-background-100">
                <i className="ri-fire-line" aria-hidden="true"></i>
                去刷热搜总榜
              </a>
              <a href="#map" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm text-background-50 transition-all hover:-translate-y-0.5 hover:bg-primary-700/40">
                <i className="ri-road-map-line" aria-hidden="true"></i>
                浏览吃瓜地图
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}